import React from "react";
import { useState, useEffect } from "react";
import { getAllDocsSnap } from "../../utils/firebase/Firebase.utils";
import { useNavigate } from "react-router-dom";
import {
  FaUserFriends,
  FaSearch,
  FaArrowLeft,
  FaHome,
  FaUser,
} from "react-icons/fa";
import UserScreenWindow from "../User/Components/UserScreenWindow";

export default function AdminResidentListMobile() {
  const [residents, setResidents] = useState([]);
  const [filteredResidents, setFilteredResidents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchResidents = async () => {
      await getAllDocsSnap("residents", (docs) => {
        setResidents(docs);
        setFilteredResidents(docs);
        setIsLoading(false);
      });
    };
    fetchResidents();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredResidents(residents);
    } else {
      const lowercasedSearch = searchTerm.toLowerCase();
      const filtered = residents.filter(
        (resident) =>
          (resident.identifier &&
            resident.identifier.toLowerCase().includes(lowercasedSearch)) ||
          (resident.owner1 &&
            resident.owner1.toLowerCase().includes(lowercasedSearch)) ||
          (resident.owner2 &&
            resident.owner2.toLowerCase().includes(lowercasedSearch))
      );
      setFilteredResidents(filtered);
    }
  }, [searchTerm, residents]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#363062]"></div>
      </div>
    );
  }

  return (
    <UserScreenWindow label="Resident Directory">
      <div className="w-full mx-auto px-3 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FaUserFriends className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Resident Directory
              </h1>
              <p className="text-xs text-gray-500">
                View and manage resident information
              </p>
            </div>
          </div>
        </div>
        {/* Search Bar */}
        <div className="relative mb-4">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="text-gray-400 text-sm" />
          </div>
          <input
            type="text"
            placeholder="Search residents..."
            value={searchTerm}
            onChange={handleSearch}
            className="w-full pl-10 pr-4 py-2.5 border rounded-md text-xs shadow-sm focus:ring-1 focus:ring-[#363062] focus:border-[#363062]"
            style={{ borderColor: "#8FCD00" }}
          />
        </div>
        {/* Residents List */}
        <div className="space-y-3">
          {filteredResidents.map((resident) => (
            <div
              key={resident.id}
              className="p-4 rounded-lg shadow-sm bg-white flex items-start"
            >
              <div className="bg-[#363062]/10 p-2.5 rounded-full mr-3">
                <FaHome className="text-[#363062] text-sm" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <div className="font-medium text-sm text-[#363062]">
                    {resident.identifier}
                  </div>
                </div>
                <div className="mt-1.5 space-y-1">
                  <div className="flex items-center text-xs text-gray-600">
                    <FaUser className="text-[#8FCD00] mr-2 text-xs" />
                    {resident.owner1}
                  </div>
                  {resident.owner2 && (
                    <div className="flex items-center text-xs text-gray-600">
                      <FaUser className="text-[#8FCD00] mr-2 text-xs" />
                      {resident.owner2}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          {filteredResidents.length === 0 && (
            <div className="text-center py-6 bg-gray-50 rounded-lg">
              <FaSearch className="mx-auto mb-2 text-gray-300 text-lg" />
              <p className="text-sm text-gray-500">No residents found</p>
            </div>
          )}
        </div>
      </div>
    </UserScreenWindow>
  );
}
